"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
var _excluded = ["className", "children", "size", "type", "icon", "src", "initials"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
var StyledAvatar = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-1hemofv-0"
})(["display:inline-flex;flex-direction:column;align-items:center;justify-content:center;", " border-radius:50%;", " ", " ", " ", ""], _kDsFoundation["default"].setColorTokenWithFallback('background: ', 'background-alternate'), function (props) {
  return props.size && (0, _styledComponents.css)(["min-width:", ";min-height:", ";max-width:", ";max-height:", ";"], props.size, props.size, props.size, props.size);
}, function (props) {
  return props.textSize && (0, _styledComponents.css)(["", " font-size:", ";text-align:center;", ""], _kDsFoundation["default"].setTypographyWithFallback({
    'font-family': 'font-secondary',
    'font-weight': 'font-medium',
    'letter-spacing': 'tracking-wide',
    'line-height': 'relaxed'
  }), props.textSize, _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-primary'));
}, function (props) {
  return props.customColor && (0, _styledComponents.css)(["background:", ";"], props.customColor);
}, function (props) {
  return props.svgSize && (0, _styledComponents.css)(["> svg{width:", ";height:", ";}"], props.svgSize, props.svgSize);
});
/* eslint-enabled */

var StyledImage = /*#__PURE__*/_styledComponents["default"].img.withConfig({
  componentId: "kds-v1__sc-1hemofv-1"
})(["border-radius:50%;", ""], function (props) {
  return props.size && (0, _styledComponents.css)(["min-width:", ";min-height:", ";max-width:", ";max-height:", ";"], props.size, props.size, props.size, props.size);
});
var defaultSize = 'large';
var MAP_COMPONENT_SIZE = {
  'x-small': '16px',
  'small': '24px',
  'medium': '32px',
  'large': '48px',
  'x-large': '64px',
  '2x-large': '96px'
};
function getComponentSize(size) {
  return MAP_COMPONENT_SIZE[size] || MAP_COMPONENT_SIZE[defaultSize];
}
var MAP_TEXT_SIZE = {
  'x-small': '8px',
  'small': '10px',
  'medium': '12px',
  'large': '16px',
  'x-large': '20px',
  '2x-large': '36px'
};
function getTextSize(size) {
  return MAP_TEXT_SIZE[size] || MAP_TEXT_SIZE[defaultSize];
}
var MAP_SVG_SIZE = {
  'x-small': '14px',
  'small': '20px',
  'medium': '28px',
  'large': '44px',
  'x-large': '60px',
  '2x-large': '90px'
};
function getSVGSize(size) {
  return MAP_SVG_SIZE[size] || MAP_SVG_SIZE[defaultSize];
}
function DefaultAvatar(props, size) {
  var avatarProps = props;
  if (size) {
    avatarProps = _objectSpread(_objectSpread({}, props), {}, {
      textSize: getTextSize(size)
    });
  }
  return /*#__PURE__*/_react["default"].createElement(StyledAvatar, avatarProps, "user");
}
var Avatar = exports.Avatar = function Avatar(_ref) {
  var className = _ref.className,
    children = _ref.children,
    size = _ref.size,
    type = _ref.type,
    icon = _ref.icon,
    src = _ref.src,
    initials = _ref.initials,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    className: className
  }, moreProps), {}, {
    size: getComponentSize(size)
  });
  var AvatarComponent;
  switch (type) {
    case 'default':
      props = _objectSpread(_objectSpread({}, props), {}, {
        svgSize: getSVGSize(size)
      });
      AvatarComponent = icon ? /*#__PURE__*/_react["default"].createElement(StyledAvatar, props, icon) : DefaultAvatar(props);
      break;
    case 'image':
      AvatarComponent = src ? /*#__PURE__*/_react["default"].createElement(StyledImage, _extends({
        src: src
      }, props)) : DefaultAvatar(props, size);
      break;
    case 'initials':
      props = _objectSpread(_objectSpread({}, props), {}, {
        textSize: getTextSize(size)
      });
      AvatarComponent = initials ? /*#__PURE__*/_react["default"].createElement(StyledAvatar, props, initials) : DefaultAvatar(props);
      break;
    default:
      AvatarComponent = DefaultAvatar(props, size);
      break;
  }
  return AvatarComponent;
};